import { OpenDialog } from "event-definitions"
import { nanoid } from "nanoid"
import { ConfirmDialogWithUserInput } from "lib/@dialogs/confirm-dialog-with-user-input"

/**
 * Displays a confirmation dialog with a given message and relevant record count that the user must type to
 * confirm, and resolves a promise with the user's response.
 *
 * @param {string} message - The message to display in the confirmation dialog.
 * @param {number} confirmValue - A string or integer value of records to display in the dialog.
 * @param {string} [title=""] - Optional title for the confirmation dialog.
 * @param {Array} [buttons=undefined] - Optional array of button definitions for the dialog.
 * @param {string} startIcon - The icon to display at the start of the dialog.
 * @return {Promise<boolean>} Promise that resolves with the user's response (true for confirmation, false otherwise).
 */
export function confirmByUserInput({
    message = "",
    confirmValue,
    title = "Remove item",
    buttons = undefined,
    startIcon = "mdi:delete",
}) {
    if (!confirmValue || confirmValue === 0 || isNaN(confirmValue) || confirmValue === "0")
        confirmValue = Math.floor(Math.random() * 9000) + 1000

    return new Promise((resolve) => {
        OpenDialog.raise({
            dialogProps: {
                maxWidth: "sm",
                fullWidth: true,
            },
            dialogId: nanoid(),
            content: (
                <ConfirmDialogWithUserInput
                    confirmValue={confirmValue.toString()}
                    buttons={buttons}
                    message={message}
                    title={title}
                    startIcon={startIcon}
                    sx={{ zIndex: 9999 }}
                />
            ),
            resolve,
        })
    })
}
